export enum Planes {
    BASIC = 'Básico',
}